import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DestinationEngagementStepRef, EngagementStepDisplay } from '../../models';
import { EngagementStepItemComponent } from '../engagement-step-item/engagement-step-item.component';

@Component({
  selector: 'app-engagement-step-list',
  templateUrl: './engagement-step-list.component.html',
  styleUrls: ['./engagement-step-list.component.scss'],
  standalone: true,
  imports: [CommonModule, EngagementStepItemComponent],
})
export class EngagementStepListComponent {
  @Input() steps: EngagementStepDisplay[];
  @Output() goToStep = new EventEmitter<DestinationEngagementStepRef>();

  /**
   * Returns the reference for the given step.
   * @param step The step to return the reference for.
   * @returns The reference for the given step.
   */
  stepReference(step: EngagementStepDisplay) {
    return {
      type: step.type,
      documentId: (step.tasks?.find(task => task.documentId))?.documentId,
    };
  }
}
